import React from 'react';
import { Field, Form, useFormikContext } from 'formik';

import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';

import { FormikInput } from '../../_core/Formik/formik-input.component';
import { FormikSelect } from '../../_core/Formik/formik-select.component';
import { FocusFirstInvalidField } from '../../_core/Formik/focus-first-invalid-field.component';
import { PrimaryButton } from '../../_core/_ui/buttons.component';
import { FormHelperText } from '../../_core/_ui/forms.component';
import { TIMEZONE_NAME_OPTIONS } from '../../../lib/timezone.constants';
import { CREATE_ASSOCIATION_FORM_ID } from './create-association-form.constants';
import { ICreateAssociationFields } from './create-association-form.types';

interface ICreateAssociationFormProps {
  submitError: React.ReactNode;
}

export const CreateAssociationForm: React.FC<ICreateAssociationFormProps> = ({ submitError }) => {
  const { isSubmitting } = useFormikContext<ICreateAssociationFields>();

  return (
    <Form id={CREATE_ASSOCIATION_FORM_ID}>
      <Field fid="caf" name="name" label="Association name" component={FormikInput} />
      <Field fid="caf" name="timezone" label="Timezone" component={FormikSelect} options={TIMEZONE_NAME_OPTIONS} />
      <Field fid="caf" name="ownerEmail" type="email" label="Owner email" component={FormikInput} />

      {submitError && <FormHelperText error>{submitError}</FormHelperText>}

      <FormControl margin="normal">
        <PrimaryButton type="submit">
          {isSubmitting ? <CircularProgress size={20} color="inherit" /> : 'Create Association'}
        </PrimaryButton>
      </FormControl>

      <FocusFirstInvalidField formId={CREATE_ASSOCIATION_FORM_ID} />
    </Form>
  );
};
